<div class="modal" (click)="closeModal($event)" *ngIf="showFilters">
  <div class="modal-content">
    <strong>
      {{ "EmergenciesListFiltersTitle" | translate }}
    </strong>

    <div
      class="d-flex flex-column align-items-center justify-content-center mt-3"
      style="width: fit-content"
    >
      <form [formGroup]="searchFilter" class="container-form-search">
        <div class="container-input-search">
          <!-- <div class="filters-input">
            <label class="label-input-search">Bairro</label>
            <mat-form-field
              id="select"
              style="
                width: 260px;
                background-color: #e5deff;
                border-radius: 8px;
              "
            >
              <mat-icon style="color: #5d53a7" matSuffix
                >keyboard_arrow_down</mat-icon
              >
              <mat-select
                formControlName="sublocalityComplaint"
                class="mat-select-search"
              >
                <mat-option [value]="'Todos'">Todos</mat-option>
                <mat-option
                  *ngFor="let sublocality of listsSublocalitys"
                  [value]="sublocality"
                >
                  {{ sublocality }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div> -->

          <div class="filters-input">
            <label class="label-input-search">
              {{ "EmergenciesListFiltersPlace" | translate }}
            </label>
            <mat-form-field
              id="select"
              style="
                width: 260px;
                background-color: #e5deff;
                border-radius: 8px;
              "
            >
              <mat-icon style="color: #5d53a7" matSuffix
                >keyboard_arrow_down</mat-icon
              >
              <mat-select
                formControlName="placeComplaint"
                class="mat-select-search"
              >
                <mat-option [value]="'Todos'">
                  {{ "EmergenciesListFiltersPlaceAll" | translate }}
                </mat-option>
                <mat-option
                  *ngFor="let place of placeComplaint"
                  [value]="place"
                >
                  {{ place }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div
            class="filters-input"
            *ngIf="searchFilter.controls['placeComplaint'].value == 'Ônibus'"
          >
            <label class="label-input-search">
              {{ "EmergenciesListFiltersBusLine" | translate }}
            </label>
            <mat-form-field
              id="select"
              style="
                width: 260px;
                background-color: #e5deff;
                border-radius: 8px;
              "
            >
              <mat-icon style="color: #5d53a7" matSuffix
                >keyboard_arrow_down</mat-icon
              >
              <mat-select formControlName="busLine" class="mat-select-search">
                <mat-option [value]="'Todos'">
                  {{ "EmergenciesListFiltersBusLineAll" | translate }}
                </mat-option>
                <mat-option *ngFor="let line of linesName" [value]="line">
                  {{ line }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="filters-input">
            <label class="label-input-search">
              {{ "EmergenciesListFiltersType" | translate }}
            </label>
            <mat-form-field
              id="select"
              style="
                width: 260px;
                background-color: #e5deff;
                border-radius: 8px;
              "
            >
              <mat-icon style="color: #5d53a7" matSuffix
                >keyboard_arrow_down</mat-icon
              >
              <mat-select
                formControlName="typeComplaint"
                multiple
                class="mat-select-search"
              >
                <mat-option [value]="'Todos'">
                  {{ "EmergenciesListFiltersTypeAll" | translate }}
                </mat-option>
                <mat-option *ngFor="let type of typesComplaint" [value]="type">
                  {{ type }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div
          style="
            margin-top: 1.5rem;
            display: flex;
            width: 100%;
            justify-content: space-between;
            margin-bottom: 15px;
          "
        >
          <div class="filters-input">
            <label class="label-input-search">
              {{ "EmergenciesListFiltersGender" | translate }}
            </label>
            <mat-form-field
              id="select"
              style="
                width: 260px;
                background-color: #e5deff;
                border-radius: 8px;
              "
            >
              <mat-icon style="color: #5d53a7" matSuffix
                >keyboard_arrow_down</mat-icon
              >
              <mat-select
                formControlName="genderComplaint"
                class="mat-select-search"
              >
                <mat-option [value]="'Todos'">
                  {{ "EmergenciesListFiltersGenderAll" | translate }}
                </mat-option>
                <mat-option [value]="'WOMAN_TRANS'">
                  {{ "EmergenciesListFiltersGenderTransWoman" | translate }}
                </mat-option>
                <mat-option [value]="'WOMAN_CIS'">
                  {{ "EmergenciesListFiltersGenderCisWoman" | translate }}
                </mat-option>
                <mat-option [value]="'MAN_TRANS'">
                  {{ "EmergenciesListFiltersGenderTransMan" | translate }}
                </mat-option>
                <mat-option [value]="'MAN_CIS'">
                  {{ "EmergenciesListFiltersGenderCisMan" | translate }}
                </mat-option>
                <mat-option [value]="'NON_BINARY'">
                  {{ "EmergenciesListFiltersGenderNonBinary" | translate }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <button
          class="btn btn-outline-secundary custom-button mt-3"
          style="font-size: 1rem"
          (click)="queryComplaints()"
        >
          {{ "EmergenciesListFiltersSubmit" | translate }}
        </button>
        <button
          class="btn btn-outline-clear custom-button clear mt-3 text-decoration-underline"
          style="font-size: 1rem"
          (click)="limparFiltros()"
        >
          {{ "EmergenciesListFiltersCleanFilters" | translate }}
        </button>
      </form>
    </div>
  </div>
</div>

<div style="background: #fffbff; overflow-x: hidden">
  <div class="row justify-content-center emergency-list-content">
    <div style="background: #fffbff; width: 100%; max-width: 100%; padding: 0">
      <div
        style="
          background: #5b43d9;
          width: 100%;
          border-bottom-left-radius: 40px;
          border-bottom-right-radius: 40px;
          margin-top: -1px;
        "
      >
        <header
          class="denounce-table-title"
          style="
            margin: 0 auto;
            max-width: 1300px;
            padding: 0;
            padding-top: 20px;
            padding-bottom: 15px;
          "
        >
          <h2 style="margin: 0 !important">
            {{ "EmergenciesListHeaderTitle" | translate }}
          </h2>
        </header>
      </div>

      <div
        class="d-flex flex-row align-items-center w-100"
        style="padding: 0 10%; margin: 2.5rem 0 0"
      >
        <div
          class="d-flex flex-column w-50 me-4"
          *ngIf="weeklyEmergencies && weeklyEmergencies > 0"
        >
          <div class="graph">
            <div class="graph-title">
              {{ "EmergenciesListWeeklyEmergenciesTitle" | translate }}
            </div>

            <div class="d-flex flex-row align-items-center">
              <div class="emergencies-card" style="margin-right: 2rem">
                <strong>{{ weeklyEmergencies || 0 }}</strong>
                {{ "EmergenciesListWeeklyEmergenciesThisWeek" | translate }}
              </div>
              <div class="d-flex flex-column">
                <canvas
                  style="max-height: 200px; width: 400px !important"
                  id="emergencies-chart"
                  baseChart
                  [datasets]="emergencyChartConfig.data"
                  [labels]="emergencyChartConfig.labels"
                  [colors]="emergencyChartConfig.colors"
                  [chartType]="'line'"
                  [options]="options"
                ></canvas>

                <div
                  class="d-flex flex-row justify-content-center"
                  style="font-size: 14px; font-weight: 400"
                >
                  {{ month }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex flex-column w-50" *ngIf="checkins.length > 0">
          <div class="graph">
            <div class="graph-title">
              {{ "EmergenciesListCheckinTitle" | translate }}
            </div>

            <div class="d-flex flex-row align-items-center">
              <div class="d-flex flex-column">
                <canvas
                  id="checkinChart"
                  style="max-height: 200px; width: 400px"
                ></canvas>

                <div
                  class="d-flex flex-row justify-content-center"
                  style="font-size: 14px; font-weight: 400"
                >
                  {{ month }}
                </div>
              </div>

              <div class="d-flex flex-column" style="margin-left: 2rem">
                <div
                  class="checkin"
                  *ngFor="let checkin of checkins; index as i"
                >
                  <div
                    class="checkin-square"
                    [style.background-color]="checkinColors[i]"
                  ></div>
                  {{ checkin }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <section
          class="section-filter"
          style="width: 100%; max-width: 1300px; margin: 0 auto"
          [ngStyle]="{
            'margin-top':
              checkins.length <= 0 &&
              (!weeklyEmergencies || weeklyEmergencies == 0)
                ? '0'
                : '2rem'
          }"
        >
          <div class="filter-container">
            <div [formGroup]="searchForm" class="filter-bar">
              <label
                class="filter__label"
                for="search"
                style="margin-right: 30px"
              >
                <span
                  class="material-icons"
                  style="padding-bottom: 3px; cursor: pointer"
                >
                  <img src="assets/icons/search.svg" alt="" />
                </span>
                <input
                  (keyup)="filterComplaint()"
                  id="search"
                  type="search"
                  class="form-control"
                  placeholder="Pesquisar..."
                  name="search"
                  required
                  formControlName="search"
                />
              </label>
              <div
                class="input-group-append"
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <button
                  (click)="setShowFilters(true)"
                  class="btn btn-outline-primary custom-button ms-3"
                >
                  <img src="assets/icons/filters.svg" alt="" />
                  {{ "EmergenciesListFiltersTitle" | translate }}
                </button>

                <button
                  class="btn btn-outline-fortiary custom-button ms-3"
                  (click)="queryComplaints()"
                >
                  {{ "EmergenciesListTableSearch" | translate }}
                </button>
              </div>
            </div>

            <div class="status-selector">
              <button
                [class.active]="!finishedStatus"
                (click)="changeTable(false)"
              >
                {{ "EmergenciesListTablePendingOcurrences" | translate }}
              </button>
              <button
                [class.active]="finishedStatus"
                (click)="changeTable(true)"
              >
                {{ "EmergenciesListTableFinishedOcurrences" | translate }}
              </button>
            </div>
          </div>
        </section>
        <!--
      <div style="width: 100%; max-width: 1300px; margin: 0 auto;">
        <form [formGroup]="searchFilter" class="search-form">
          <div class="form-row search-row">
            <div class="form-group col-md-2">
              <label class="filters-name">Tipo</label>
              <select (change)="queryComplaints()" formControlName="" class="form-control filters-select fa-caret-down">
                <option>
                  Todos
                </option>
                <option *ngFor="let type of typesComplaint">
                  {{ type }}
                </option>
              </select>
            </div>
            <div class="form-group  col-md-2">
              <label class="filters-name">Linha de ônibus</label>
              <select (change)="queryComplaints()" class="form-control filters-select fa-caret-down">
                <option>
                  Todas
                </option>
                <option *ngFor="let line of linesName">
                  {{ line }}
                </option>
              </select>
            </div>
            <div class="form-group  col-md-2">
              <label class="filters-name">Lugar de ocorrência</label>
              <select (change)="queryComplaints()" class="form-control filters-select fa-caret-down">
                <option>
                  Todos
                </option>
                <option *ngFor="let place of placeComplaint">
                  {{ place }}
                </option>
              </select>
            </div>
            <div class="form-group col-md-2 d-btn-filter">
              <button id="btnSubmitFilter" (click)="queryComplaints()" type="submit"
                class="btn btn-primary">Filtrar</button>
            </div>
          </div>
        </form>
      </div>
      -->

        <div
          class="card card-table"
          style="width: 100%; height: auto; background: #fffbff"
        >
          <div
            *ngIf="loading"
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
              height: 60vh;
              width: 100%;
            "
          >
            <mat-spinner></mat-spinner>
          </div>

          <div
            *ngIf="!loading"
            style="max-width: 1300px; margin: 0 auto"
            class="table__wrapper"
          >
            <table mat-table [dataSource]="dataSourceDenounces">
              <ng-container matColumnDef=" " class="column-list">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  style="text-align: left !important"
                ></th>
                <td
                  (click)="seeDetails(element._id)"
                  mat-cell
                  *matCellDef="let element"
                  style="cursor: pointer; font-size: 16px"
                >
                  <div
                    style="
                      display: flex;
                      width: 100%;
                      height: 100%;
                      gap: 10px;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <img src="assets/icons/eyeWithBg.svg" alt="" />
                  </div>
                </td>
              </ng-container>
              <!-- ID Column -->
              <ng-container matColumnDef="sublocality" class="column-list">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  style="text-align: left !important"
                >
                  {{ "EmergenciesListTableSublocality" | translate }}
                </th>
                <td
                  (click)="seeDetails(element._id)"
                  mat-cell
                  *matCellDef="let element"
                  style="cursor: pointer; font-size: 16px"
                >
                  <div
                    style="
                      display: flex;
                      width: 55%;
                      height: 100%;
                      gap: 10px;
                      align-items: center;
                      justify-content: space-between;
                    "
                  >
                    <p style="margin: 0; width: 80%; text-align: left">
                      {{ element.sublocality }}
                    </p>

                    <div class="emergency-tag">
                      <span class="red-ball"></span>
                      {{ getTimeAgo(element.datetime) }}
                    </div>
                  </div>
                </td>
              </ng-container>

              <!-- Place Column -->
              <ng-container matColumnDef="place" class="column-list">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  style="text-align: left !important"
                >
                  {{ "EmergenciesListTablePlace" | translate }}
                </th>
                <td
                  (click)="seeDetails(element._id)"
                  mat-cell
                  *matCellDef="let element"
                  style="text-align: left !important"
                >
                  {{ element.place }}
                </td>
              </ng-container>

              <!-- Type Column -->
              <ng-container matColumnDef="type" class="column-list">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  style="text-align: left !important"
                >
                  {{ "EmergenciesListTableType" | translate }}
                </th>
                <td
                  (click)="seeDetails(element._id)"
                  mat-cell
                  *matCellDef="let element"
                  style="text-align: left !important"
                >
                  <div
                    *ngFor="let tipo of element.type"
                    style="
                      border-radius: 100px;
                      background: var(
                        --material-theme-ref-primary-primary-80,
                        #c8bfff
                      );
                      display: inline-flex;
                      padding: 4px 8px;
                      justify-content: center;
                      align-items: center;
                      margin-right: 5px;
                      gap: 8px;
                    "
                  >
                    {{ tipo }}
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr
                mat-row
                class="ocurrence-row"
                *matRowDef="let row; columns: displayedColumns"
              ></tr>
            </table>
          </div>
          <mat-paginator [pageSizeOptions]="[5, 10, 15]" showFirstLastButtons>
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
